module.exports = __webpack_public_path__ + "img/icon_pay_completed.d48bda48.png";